export default {
  country_locale: 'cz-CZ',
  wia_title: 'Webová online pomoc',
  wia_need_help: 'Potřebuji pomoc s',
  wia_model_name: 'Název modelu je',
  wia_back: '< změnit',
  wia_confirm: 'Potvrdit',
  wia_issue_title: 'Jaký máte problém?',
  wia_issue_concern: 'Můj problém se týká',
  wia_issue_specific: 'Specifikujte problém',
  wia_possible_solution: 'Možná řešení',
  wia_solved_issue: 'Vyřešilo to problém?',
  wia_smile_up_popup_text1: 'Objevte naše plány ochrany',
  wia_smile_down_popup_title: 'Je nám to líto',
  wia_smile_down_popup_text1: 'Přejděte ke druhému kroku',
  wia_smile_down_popup_or_text: 'or',
  wia_smile_down_popup_text2: 'Přejděte na kontaktní stránku',
  wia_closed: 'Zavřít x',
  wia_feedback_ok: 'Ano!',
  wia_find_another_solution: 'Najít jiné řešení',
  wia_feedback_title: 'Jsme rádi, že se problém podařilo vyřešit!',
  wia_feedback_text1: 'Navštivte náš obchod se speciálními nabídkami právě pro vás',
  wia_feedback_text2: 'Zjistěte více o našich nejnovějších chytrých technologiích',
  wia_need_more_help: 'Potřebujete další pomoc?',
  wia_optional_label: '(nepovinné)',
  wia_no_solution: 'Je nám líto, ale nenalezli jsme pro vás řešení problému online. Prosíme klikněte zde pro další podporu.',
  wia_all_solution: 'Všechny výsledky',
  wia_all_categories: 'Všechny kategorie',
  wia_seo_l1_issue: 'Všechny chyby podle kategorií',
  wia_seo_wp_country_name: '',
  wia_seo_bk_country_name: '',
  wia_seo_hp_country_name: '',
  wia_seo_id_country_name: 'CZ',
  wia_seo_wp_meta_title: 'Problémy a řešení',
  wia_seo_bk_meta_title: 'Problémy a řešení',
  wia_seo_hp_meta_title: 'Problémy a řešení',
  wia_seo_id_meta_title: 'Problémy a řešení',
  wia_seo_wp_meta_description: 'Vyřešte problémy s vaším výrobkem díky několika klikům na naší online technické podpoře Whirlpool Česká republika',
  wia_seo_bk_meta_description: 'Vyřešte problémy s vaším výrobkem díky několika klikům na naší online technické podpoře Bauknecht Česká republika',
  wia_seo_hp_meta_description: 'Vyřešte problémy s vaším výrobkem díky několika klikům na naší online technické podpoře Hotpoint Česká republika',
  wia_seo_id_meta_description: 'Vyřešte problémy s vaším výrobkem díky několika klikům na naší online technické podpoře Indesit Česká republika',
  wia_seo_wp_meta_description_home: '',
  wia_seo_bk_meta_description_home: '',
  wia_seo_hp_meta_description_home: '',
  wia_seo_id_meta_description_home: ''
}
